import React from "react";

import { SalesLayout } from "../../features/sales/components/layout";
import ItemRoutes from "./item";
import StoreRoutes from "./store/StoreRoutes";
import TableRoutes from "./table/TableRoutes";

const SaleAdminLangPage = React.lazy(() => import("../../pages/sales/SaleAdminLangPage"));
const EquipmentPage = React.lazy(() => import("../../pages/sales/EquipmentPage"));
const OrgLanguagePage = React.lazy(() => import("../../pages/sales/OrgLanguagePage"));
const OrgInfoPage = React.lazy(() => import("../../pages/sales/OrgInfoPage"));
const AmazeLinkPage = React.lazy(() => import("../../pages/sales/AmazeLinkPage"));
// const ApiKeysPage = React.lazy(() => import("../../pages/sales/ApiKeysPage"));
const SaleRoutes = [
    {
        element: <SalesLayout />,
        path: "org",
        children: [
            {
                path: ":orgId",
                children: [
                    {
                        path: "info",
                        element: <OrgInfoPage />,
                    },
                    {
                        path: "amaze-link",
                        element: <AmazeLinkPage />,
                    },
                    // {
                    //     path: "api-keys",
                    //     element: <ApiKeysPage />,
                    // },
                    {
                        path: "item",
                        children: ItemRoutes,
                    },
                    {
                        path: "admin-language",
                        element: <SaleAdminLangPage />,
                    },
                    {
                        path: "equipment",
                        element: <EquipmentPage />,
                    },
                    {
                        path: "language",
                        element: <OrgLanguagePage />,
                    },
                    {
                        path: "store",
                        children: StoreRoutes,
                    },
                    {
                        path: "table",
                        children: TableRoutes,
                    },
                ],
            },
        ],
    },
];

export default SaleRoutes;
